module.exports = __webpack_public_path__ + "img/erp-feature3.3b60a9bd.png";